import api from '../../plugins/api';

const getContainerCard = (params) => {
  return api.get('/api/shop/getContainerCard', params);
};

export default getContainerCard;
